// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon--2VZXF","contact":"contact--1QHdl","date":"date--1LZXi","conductedCallsTableTag":"conductedCallsTableTag--2IRrM"};